import { axiosInstance } from './base'

export interface InternalKeyResponse {
  id?: number
  name?: string
  key?: string
  status?: string
  created_at?: number
  expires_at?: number
}

export interface ListInternalKeysResponse {
  items?: InternalKeyResponse[]
  total?: number
}

export interface CreateInternalKeyRequest {
  name?: string
  expires_in?: number
}

const basePath = '/clinic/api/v1'

export function listInternalKeys(limit?: number, page?: number) {
  return axiosInstance.get<ListInternalKeysResponse>(
    `${basePath}/internal/keys`,
    {
      params: { limit, page }
    }
  )
}

export function createInternalKey(req?: CreateInternalKeyRequest) {
  return axiosInstance.post<InternalKeyResponse>(
    `${basePath}/internal/keys`,
    req
  )
}

export function deleteInternalKey(id: number) {
  return axiosInstance.delete(`${basePath}/internal/keys/${id}`)
}
